/** KAN-718: настройки своего почтового ящика: загрузка и изменения. */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { emailMailboxApi } from '@/services/api/emailMailbox';
import type { MailboxBody } from '@/types/emailMailbox';

export const EMAIL_MAILBOX_QUERY_KEY = ['email-mailbox'] as const;

export function useEmailMailbox(enabled = true) {
  return useQuery({
    queryKey: EMAIL_MAILBOX_QUERY_KEY,
    queryFn: emailMailboxApi.get,
    staleTime: 30_000,
    enabled,
  });
}

export function useEmailMailboxMutations() {
  const client = useQueryClient();
  const refresh = (): void => {
    client.invalidateQueries({ queryKey: EMAIL_MAILBOX_QUERY_KEY });
  };
  return {
    save: useMutation({
      mutationFn: (data: MailboxBody) => emailMailboxApi.save(data),
      onSuccess: (mailbox) => client.setQueryData(EMAIL_MAILBOX_QUERY_KEY, mailbox),
    }),
    reset: useMutation({ mutationFn: () => emailMailboxApi.reset(), onSuccess: refresh }),
    // Проверка сохранённого (без тела) пишется в last_check: перечитываем ящик.
    // Проверка полей формы не перечитывает, иначе форма сбросится к сохранённому.
    check: useMutation({
      mutationFn: (data?: MailboxBody) => emailMailboxApi.check(data),
      onSuccess: (_result, data) => {
        if (!data) refresh();
      },
    }),
    testSend: useMutation({ mutationFn: (to: string) => emailMailboxApi.testSend(to) }),
  };
}
